import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { SearchableDropdown } from 'elements/Inputs/FormInput/SearchableDropdown';
import { Colors } from 'helpers/Colors';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import IconButton from '@material-ui/core/IconButton';
import { setSelectedTRF, resetTestPointVal } from 'journeys/portal/Forms/Forms.actions';
import { setCurrentView } from 'journeys/portal/Home/Home.actions';
import { clearSRAData } from 'journeys/portal/Forms/FormsP8.actions';
import { SelectTrfText, SelectDropdown, SelectArrow, DropDownStyle } from './Footer.styled';

export const selectForm = 'Select Form';

const TrfDropdownSelection = (props) => {
    const { settingSelectedTRF, trfMasterList, setCurrentAppView, resetSRAData, workType, clearTestPointValue } = props;
    const isNonMoFeatureEnabled = useSelector(({ Home }) => Home.isNonMoFeatureEnabled);
    const activeTRFId = isNonMoFeatureEnabled
        ? trfMasterList?.filter(x => x.Status === 'Active' && x.TrfShortDesc !== 'Not In MRAT')
        : trfMasterList?.filter(x => x.Status === 'Active' && x.TrfShortDesc !== 'Not In MRAT'
            && x.WorkType.toLowerCase() === workType.toLowerCase());
    const [selectTrfId, setSelectTrfId] = useState('');
    const actionButtonHandler = () => {
        settingSelectedTRF(selectTrfId);
        clearTestPointValue();
        resetSRAData();
        setCurrentAppView(selectTrfId.trim());
    };
    const formHandler = (obj) => {
        setSelectTrfId(trfMasterList.find(x => x.TrfShortDescReplaceWhenActive === obj?.trfMasterList)?.TrfId);
    };
    return (
        <div style={{ position: 'relative' }}>
            <div className="container">
                <div>
                    <SelectTrfText>
                        {`${selectForm}`}
                    </SelectTrfText>
                </div>
                <DropDownStyle>
                    <SelectDropdown>
                        <SearchableDropdown
                            width="224px"
                            height="2rem"
                            name="trfMasterList"
                            value={activeTRFId.find(x => x.TrfId === selectTrfId)?.TrfShortDescReplaceWhenActive || ''}
                            handleChange={formHandler}
                            placeholder="Search Form"
                            options={activeTRFId
                                .map(x => ({ name: x.TrfShortDescReplaceWhenActive, value: x.TrfShortDescReplaceWhenActive }))}
                            alignItems="flex-start"
                            flexDirection="column"
                            selectMarginLeft="15px"
                        />
                    </SelectDropdown>
                    <SelectArrow>
                        <IconButton
                            disabled={!selectTrfId}
                            component="span"
                            onClick={() => actionButtonHandler()}
                            onChange={formHandler}
                            style={{ color: selectTrfId ? Colors.green : Colors.grey }}
                        >
                            <ArrowForwardIosIcon
                                id="ActionButtonArrow"
                                style={{ fontSize: '33px' }}
                            />
                        </IconButton>
                    </SelectArrow>
                </DropDownStyle>
            </div>
        </div>
    );
};

TrfDropdownSelection.propTypes = {
    clearTestPointValue: PropTypes.func,
    resetSRAData: PropTypes.func,
    setCurrentAppView: PropTypes.func,
    settingSelectedTRF: PropTypes.func,
    trfMasterList: PropTypes.array,
    workType: PropTypes.string
};

const mapStateToProps = ({ Home, Forms }) => ({
    workType: Home.selectedWorkType,
    trfMasterList: Home.trfMasterList,
    formData: Forms.formData
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    settingSelectedTRF: (selectedTrfId) => dispatch(setSelectedTRF(selectedTrfId)),
    setCurrentAppView: (view) => dispatch(setCurrentView(view)),
    resetSRAData: () => dispatch(clearSRAData()),
    clearTestPointValue: () => dispatch(resetTestPointVal())
});
export default connect(mapStateToProps, mapDispatchToProps)(TrfDropdownSelection);
